export default "__VITE_ASSET__BjR96WzK__"